module.exports = __webpack_public_path__ + "static/media/datatrack-mobile.b72c7bf3.svg";